// extracted by mini-css-extract-plugin
export default {"avatar":"account_avatar__3wGXO","image":"account_image__s00Oi","isSelected":"account_isSelected__8ry-q"};